
import { defineComponent } from "vue";
import TokenService from "@/services/TokenService";
import ResponseData from "@/_models/ResponseData";
import { Helper } from "@/utils/Helper";
import store from "@/store/index";
import tokensListTokenBoxComponent from "@/modules/tokens/components/tokensListTokenBoxComponent.vue";

export default defineComponent({
  data: function () {
    return {
      testnetTokens: [],
      mainnetTokens: [],
      userData: store.getters["auth/user"] ?? "",
      interval: "",
      showLoader: false,
      currentTab: 'testnet',
      mainnetTokenSymbols: [],
    };
  },
  name: "viewTokensList",
  components: {
    tokensListTokenBoxComponent,
  },
  methods: {
    getTokensList() {
      if (this.userData !== "") {
        TokenService.getTokenListByWalletAddress(this.userData.testnetWalletAddress, 'testnet')
          .then((response: ResponseData) => {
            if (response.status === 200) {
              this.testnetTokens = response.data;
            }
            this.showLoader = false;
          })
          .catch((error) => {
            this.showLoader = false;
            Helper.endpointErrorHandling(error, "You have not connected your wallet yet.", "warning");
          });
        if(this.userData.mainnetWalletAddress){
          TokenService.getTokenListByWalletAddress(this.userData.mainnetWalletAddress, 'mainnet')
            .then((response: ResponseData) => {
              if (response.status === 200) {
                this.mainnetTokens = response.data;
                let scope = this;
                this.mainnetTokens.forEach(function (token: any) {
                  scope.mainnetTokenSymbols.push(token.symbol)
                });
              }
              this.showLoader = false;
            })
            .catch((error) => {
              this.showLoader = false;
              // Helper.endpointErrorHandling(error, "You have not connected your wallet yet.", "warning");
            });
        }
      }
    },
  },
  computed: {
    assetUrl() {
      return store.getters['config/assetUrl'];
    },
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
  },

  mounted() {
    this.showLoader = true;
    this.getTokensList();
  },

  created() {
    this.interval = setInterval(() => {
      this.getTokensList();
    }, 15000);
  },

  beforeUnmount() {
    clearInterval(this.interval);
  },
});
